import 'dayjs/locale/es'

import { Grid, TextField } from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { FunctionComponent, useEffect } from 'react'
import { Controller, UseFormReturn } from 'react-hook-form'

import { InputCodigoMask } from '../../../base/components/MyInputs/InputCodigoMask'
import useAuth from '../../../base/hooks/useAuth'
import { ActionLoteForm, actionLoteForm } from '../interfaces'
import { LoteInputProps } from '../../../interfaces/lote.ts'
import SimpleDatePicker from '../../../base/components/MyInputs/SimpleDatePicker.tsx'
import dayjs from 'dayjs'

interface OwnProps {
  form: UseFormReturn<LoteInputProps>
  action: ActionLoteForm
}

type Props = OwnProps

const LoteForm: FunctionComponent<Props> = (props) => {
  const {
    form: {
      control,
      formState: { errors },
    },
    action,
  } = props

  const {
    user: { sucursal },
  } = useAuth()

  useEffect(() => {}, [])

  return (
    <form>
      <Grid container columnSpacing={2} rowSpacing={3}>
        <Grid size={12}>
          Sucursal: {sucursal.codigo} - {sucursal.direccion}
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Controller
            name="codigoLote"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Código del Lote"
                size="small"
                fullWidth
                disabled={[actionLoteForm.UPDATE].includes(action)}
                slotProps={{
                  input: {
                    inputComponent: InputCodigoMask as any,
                  },
                }}
                error={Boolean(errors.codigoLote)}
                helperText={errors.codigoLote?.message}
              />
            )}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 8 }}>
          <Controller
            name="descripcion"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Descripción"
                size="small"
                fullWidth
                error={!!errors.descripcion}
                helperText={errors.descripcion?.message}
              />
            )}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 4 }}>
          <Controller
            name={'fechaAdmision'}
            control={control}
            render={({ field }) => (
              <SimpleDatePicker
                label="Fecha de Admisión"
                value={field.value ? dayjs(field.value) : null}
                onChange={field.onChange}
              />
            )}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 4 }}>
          <Controller
            name={'fechaFabricacion'}
            control={control}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                <DatePicker
                  label="Fecha de Fabricación"
                  value={field.value}
                  onChange={field.onChange}
                  name={'fechaFabricacion'}
                  slotProps={{
                    textField: {
                      error: Boolean(errors.fechaFabricacion),
                      size: 'small',
                      fullWidth: true,
                      helperText: errors.fechaFabricacion?.message,
                    },
                  }}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 4 }}>
          <Controller
            name="fechaVencimiento"
            control={control}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                <DatePicker
                  {...field}
                  label="Fecha de Vencimiento"
                  value={field.value}
                  slotProps={{
                    textField: {
                      error: Boolean(errors.fechaVencimiento),
                      size: 'small',
                      fullWidth: true,
                      helperText: errors.fechaVencimiento?.message,
                    },
                  }}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Controller
            name="atributo1"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Atributo 1"
                size="small"
                fullWidth
                error={Boolean(errors.atributo1)}
                helperText={errors.atributo1?.message}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Controller
            name="atributo2"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Atributo 2"
                size="small"
                fullWidth
                value={field.value}
                error={Boolean(errors.atributo2)}
                helperText={errors.atributo2?.message}
              />
            )}
          />
        </Grid>
      </Grid>
    </form>
  )
}
export default LoteForm
